import { render } from "./RolePermissions.vue?vue&type=template&id=7d0a10f8&scoped=true"
import script from "./RolePermissions.vue?vue&type=script&lang=js"
export * from "./RolePermissions.vue?vue&type=script&lang=js"

import "./RolePermissions.vue?vue&type=style&index=0&id=7d0a10f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d0a10f8"]])

export default __exports__